import * as React from 'react';
import { ReactNode, useCallback, useState } from 'react';
import { createUseStyles } from 'react-jss';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const useStyles = createUseStyles({
  modalWrapper: {
    color: '#000',
    backgroundColor: '#eceff1',
    position: 'fixed',
    right: 0,
    left: 0,
    top: 0,
    padding: '16px 45px 16px 20px',
    zIndex: 100,
    transition: 'transform .25s ease-in-out,opacity .25s ease-in-out',
    transform: 'translateY(-100%)',
    fontFamily: 'Roboto, Helvetica, Arial',
    opacity: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      padding: '16px 20px 16px 20px'
    }
  },
  showModal: {
    opacity: 1,
    transform: 'translateY(0)'
  },
  closeButton: {
    position: 'absolute',
    top: '50%',
    right: 15,
    width: 22,
    height: 22,
    zIndex: 100,
    background: 'transparent',
    transform: 'translateY(-50%)',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    '&:before, &:after': {
      content: '""',
      display: 'inline-block',
      position: 'absolute',
      width: '100%',
      height: 2,
      top: 10,
      left: 0,
      background: '#000',
      borderRadius: '50px'
    },
    '&:before': {
      transform: 'rotate(45deg)'
    },
    '&:after': {
      transform: 'rotate(-45deg)'
    },
    '@media (max-width: 768px)': {
      top: 30
    }
  },
  modalInfo: {
    marginRight: 15,
    fontSize: 14,
    '& span': {
      paddingRight: 10
    },
    '& a': {
      color: '#1976d2'
    },
    '@media (max-width: 768px)': {
      marginRight: 30,
      marginBottom: 15
    }
  },
  modalButtons: {
    display: 'flex',
    minWidth: 180,
    '& button': {
      margin: '0 5px'
    },
    '@media (max-width: 768px)': {
      width: '100%',
      '& button': {
        flex: 1
      }
    }
  },
  settingModal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 550,
    backgroundColor: '#eceff1',
    padding: 20,
    fontFamily: 'Roboto, Helvetica, Arial'
  },
  settingCloseButton: {
    top: 20,
    transform: 'none',
    '&:before, &:after': {
      background: '#000'
    }
  },
  checkboxWrapper: {
    margin: '40px 0 25px'
  },
  label: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #dee2e6',
    padding: '15px 0',
    '& p': {
      fontSize: 12,
      marginRight: 20
    }
  }
});

interface AlertModalProps {
  content: ReactNode;
}

export const AlertModal: React.FC<AlertModalProps> = ({ content }) => {
  const styles = useStyles();

  const [isShowModal, setIsShowModal] = useState<boolean>(true);

  return (
    <>
      <Box
        className={`${styles.modalWrapper} ${isShowModal && styles.showModal}`}
      >
        <Box
          className={styles.closeButton}
          onClick={() => setIsShowModal(false)}
        ></Box>
        <Box className={styles.modalInfo}>{content}</Box>
      </Box>
    </>
  );
};
